'use client';

import React, { useCallback, useContext } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import Chip from '@/src/app/components/Chip/Chip.tsx';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import { CatalogRequestParams } from '@/src/lib/category/types.ts';
export type FilterChipProps = {
  params: Array<{
    name: string;
    value: string;
  }>;
  label: string;
};
export default function FilterChip({
  params,
  label
}: FilterChipProps) {
  const pathname = usePathname();
  const router = useRouter();
  const {
    startTransition,
    isPending
  } = useContext(LayoutTemplateContext);
  const handleClose = useCallback(() => {
    startTransition(async () => {
      const currentSearchParams = new URLSearchParams(window.location.search);
      params.forEach(({
        name,
        value
      }) => {
        currentSearchParams.delete(name, value.toString());
      });
      currentSearchParams.set(CatalogRequestParams.PAGE, '1');
      router.push(decodeURI(`${pathname}?${currentSearchParams.toString()}`));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return <div className="space-x-2.5">
      <Chip onClose={handleClose} key="value" disabled={isPending}>
        {label}
      </Chip>
    </div>;
}